import React, { createContext } from 'react';

const CustomNodeComponentContext = createContext(null);

export default CustomNodeComponentContext;
